import client from "../Client/HttpClient";
import { IEnrollmentAppliedDiscountstModel } from "@/interfaces/modules";

const ApiPath = "EnrollmentAppliedDiscounts";

export default {
    GetEnrollmentDiscounts: (data: IEnrollmentAppliedDiscountstModel): Promise<IEnrollmentAppliedDiscountstModel[]> => client.get(`${ApiPath}/byEnrollment/${data.EnrollmentId}`),
    GetEnrollmentDiscountById: (data: IEnrollmentAppliedDiscountstModel): Promise<IEnrollmentAppliedDiscountstModel> => client.get(`${ApiPath}/${data.Id}`),
    PostEnrollmentDiscount: (data: IEnrollmentAppliedDiscountstModel): Promise<IEnrollmentAppliedDiscountstModel> => client.post(`${ApiPath}`, data)
};
